import Vue from 'vue';

export default function (logInfo, type = 'log') {
  if (process.env.NODE_ENV !== 'production') console[type](logInfo);
  if(Vue?.$appInsights) {
    Vue.$appInsights.trackEvent({
      name: `tracker console.${type}`,
      properties: logInfo
    });
  }
}
